import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { useState } from "react";
import {
  AddressFormElement,
  AddressFormElementExecution,
} from "../../../types";
import { FormElementChangeType } from "../FormBuilder";

enum AddressFormDataType {
  EXPANDED = 0,
  CONDENSED,
  MANUAL,
}

export const AddressSideSectionDisplay = ({
  element,
  onChange,
}: {
  element: AddressFormElement;
  executionData?: AddressFormElementExecution;
  onChange: (props: FormElementChangeType) => void;
}) => {
  const [type, setType] = useState<AddressFormDataType>(
    element.condensed
      ? AddressFormDataType.CONDENSED
      : element.manual
        ? AddressFormDataType.MANUAL
        : AddressFormDataType.EXPANDED,
  );

  const [canExpandChecked, setCanExpandChecked] = useState<boolean>(
    element.canExpand || false,
  );
  const [isStrict, setIsStrict] = useState<boolean>(element.strict || false);

  return (
    <FormControl>
      <FormLabel id="form-element-address-type-label">Address</FormLabel>

      <FormGroup aria-labelledby="form-element-address-type-label">
        <FormControlLabel
          control={<Checkbox checked={isStrict} />}
          label="Strict"
          onChange={(_, value) => {
            setIsStrict(value);
            onChange({
              changeType: "update",
              newElement: {
                ...element,
                strict: value,
              },
            });
          }}
        />
      </FormGroup>

      <FormControl>
        <FormLabel id="form-element-text-type-label">Mode</FormLabel>
        <RadioGroup
          name="form-element-address-type"
          value={type}
          onChange={(e, value) => {
            const newType = parseInt(value);
            setType(newType);
            if (newType == AddressFormDataType.EXPANDED) {
              setCanExpandChecked(false);
              onChange({
                changeType: "update",
                newElement: {
                  ...element,
                  condensed: false,
                  manual: false,
                  canExpand: false,
                },
              });
            }

            if (newType == AddressFormDataType.MANUAL) {
              setCanExpandChecked(false);
              onChange({
                changeType: "update",
                newElement: {
                  ...element,
                  condensed: false,
                  manual: true,
                  canExpand: false,
                },
              });
            }

            if (newType == AddressFormDataType.CONDENSED) {
              onChange({
                changeType: "update",
                newElement: {
                  ...element,
                  condensed: true,
                  manual: false,
                },
              });
            }
          }}
        >
          <FormControlLabel
            value={AddressFormDataType.EXPANDED}
            label="Full"
            control={<Radio />}
          />
          <FormControlLabel
            value={AddressFormDataType.CONDENSED}
            label="Condensed"
            control={<Radio />}
          />
          {type == AddressFormDataType.CONDENSED && (
            <FormControl>
              <FormGroup sx={{ pl: 5 }}>
                <FormControlLabel
                  control={<Checkbox checked={canExpandChecked} />}
                  label="User Can Expand"
                  onChange={(_, value) => {
                    setCanExpandChecked(value);
                    onChange({
                      changeType: "update",
                      newElement: {
                        ...element,
                        canExpand: value,
                      },
                    });
                  }}
                />
              </FormGroup>
            </FormControl>
          )}
          <FormControlLabel
            value={AddressFormDataType.MANUAL}
            label="Manual"
            control={<Radio />}
          />
        </RadioGroup>
      </FormControl>
    </FormControl>
  );
};
